<header>
  <h1>
    <lib-feature-description/>
  </h1>
  <div class="tool-bar">
    <lib-feature-tags/>
    <lib-feature-sorting-selector/>
    <lib-feature-display-selector [showTileOptions]="true"/>
    <lib-sidebar-toggle
      [sidebar]="sidebar"
      [icon]="SvgSpriteIcon.Filter"
    />
  </div>
</header>

<lib-sidebar
  #sidebar
  title="Filters"
  (dynamic)="onSidebarDynamic($event)"
  [(hidden)]="sidebarHidden"
>
  <lib-feature-dimension-selector/>
  <lib-feature-measure-selector/>
  <lib-feature-period-selector/>
  <lib-feature-tree-filters/>
  <lib-feature-include-total/>
  <lib-feature-highlight-selector/>
</lib-sidebar>
<main>
  <lib-feature-tile-preview
    [layout]="layout()"
    [reportPath]="PagePath.ReportView"
  />
</main>

@if (isAIAssistantEnabled()) {
  <lib-feature-insights/>
}
